const GRT = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10.0417 19.9792C15.5646 19.9792 20.0417 15.502 20.0417 9.97916C20.0417 4.45631 15.5646 -0.0208435 10.0417 -0.0208435C4.5189 -0.0208435 0.041748 4.45631 0.041748 9.97916C0.041748 15.502 4.5189 19.9792 10.0417 19.9792Z"
        fill="#6747ED"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.89575 11.2708C8.41658 11.2708 7.22908 10.0833 7.22908 8.60416C7.22908 7.12499 8.41658 5.93749 9.89575 5.93749C11.3749 5.93749 12.5624 7.12499 12.5624 8.60416C12.5624 10.0833 11.3749 11.2708 9.89575 11.2708ZM9.89575 4.60416C12.1041 4.60416 13.8958 6.39582 13.8958 8.60416C13.8958 10.8125 12.1041 12.6042 9.89575 12.6042C7.68742 12.6042 5.89575 10.8125 5.89575 8.60416C5.89575 6.39582 7.68742 4.60416 9.89575 4.60416ZM13.7083 12.8125C13.9791 13.0833 13.9791 13.5 13.7083 13.75L11.0416 16.4167C10.7708 16.6875 10.3541 16.6875 10.1041 16.4167C9.83325 16.1458 9.83325 15.7292 10.1041 15.4792L12.7708 12.8125C13.0208 12.5417 13.4583 12.5417 13.7083 12.8125ZM15.2499 5.27082C15.2499 5.64582 14.9583 5.93749 14.5833 5.93749C14.2083 5.93749 13.9166 5.64582 13.9166 5.27082C13.9166 4.89582 14.2083 4.60416 14.5833 4.60416C14.9374 4.60416 15.2499 4.89582 15.2499 5.27082Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GRT;
